// List of keys used by the circuit navigator components

export const navigator = {
  styles: Symbol('Navigator prop: styles for dynamic navigator components.')
}
